import { useEffect, useState } from "react"
import { api, urls } from '../../../services/api'
import { Item } from "./components/Item"
import { IMenu } from '../../../types/listItems'
import { MenuItem } from "./components/MenuItem"
import { ChevronRight, LayoutGrid } from 'lucide-react'
import { Section } from "../../ui/Section"
import { SectionTitle } from "../../ui/SectionTitle"
import { Button } from "../../ui/Button"

export function Services() {
	const [listMenu, setListMenu] = useState<IMenu[]>([])
	const [menuSelected, setMenuSelected] = useState<IMenu>()

	useEffect(() => {
		(async () => {
			const response = await api.get(urls.Services)
			setListMenu(response.data)
			setMenuSelected(response.data[0])
		})()
	}, [])

	return (
		<Section>
			<SectionTitle title="Serviços Online" icon={<LayoutGrid size={24} className="text-secondary" />} />

			<div className="w-full flex flex-col shadow-premium hover:shadow-premium-hover transition-all duration-300 dark:shadow-premium-dark rounded-3xl overflow-hidden border border-border-default dark:border-white/10 dark:bg-white/5 backdrop-blur-sm">
				{/* Tab Header */}
				<div className="w-full bg-secondary dark:bg-primary-dark flex flex-row items-stretch">
					<div className="flex flex-1 overflow-x-auto no-scrollbar">
						{listMenu.map((item, index) => (
							<MenuItem
								key={index}
								idActual={menuSelected?.id || 0}
								id={item.id}
								title={item.menu}
								onClick={() => setMenuSelected(item)}
							/>
						))}
					</div>
				</div>

				{/* Tab Content */}
				<div className="w-full bg-surface-alt/50 dark:bg-surface-dark-alt p-8 lg:px-12 lg:pb-12 transition-colors flex flex-col">
					<ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-4 list-none p-0 m-0 mb-12">
						{!!menuSelected && menuSelected.servicos.map((service, index) => (
							<Item
								key={index}
								titulo={service.titulo}
								cod_servico={service.cod_servico}
							/>
						))}
					</ul>

					<div className="w-full flex justify-center mt-auto border-t border-border-default/30 dark:border-white/5 pt-8">
						<Button
							variant="secondary"
							size="lg"
							className="w-full lg:w-fit flex items-center justify-center gap-2 group border-none cursor-pointer hover:scale-105 active:scale-95 transition-all shadow-lg"
							onClick={() => window.open('https://servicos.itajai.sc.gov.br/', '_blank')}
						>
							<span className="font-bold">Veja todos os serviços</span>
							<ChevronRight size={18} className="group-hover:translate-x-1 transition-transform" />
						</Button>
					</div>
				</div>
			</div>


		</Section>
	)
}